import styles from "../dropdown.css.js";
import { useIsWindowSmall } from "../../../../lib/device-utils.js";
import { ROUTES } from "../../../../routes.js";
import { DropdownLink } from "./DropdownLink.jsx";

/**
 * Renders a list of admin-specific dropdown links.
 * @param {Object} props - The properties object.
 * @param {Function} props.close - Function to close the dropdown.
 * @param {string} props.linkHost - Host for the link paths.
 * @return {JSX.Element} The rendered admin dropdown links component.
 */
export function DropdownLinksWhenAdmin({ close, linkHost }) {
  const onMobile = useIsWindowSmall();
  return (
    <div className={styles.adminLinks}>
      <p className={styles.adminLinksTitle}>
        {onMobile ? "Du bist Admin!" : "Admin Powers"}
      </p>
      {!onMobile && (
        <>
          <DropdownLink
            close={close}
            linkHost={linkHost}
            to={ROUTES.admins.getUrl()}
            size="sm"
          >
            Admins
          </DropdownLink>
          <DropdownLink
            close={close}
            linkHost={linkHost}
            to={ROUTES.templates.getUrl()}
            size="sm"
          >
            Template-Lernreisen
          </DropdownLink>
          <DropdownLink
            close={close}
            linkHost={linkHost}
            to={ROUTES.administrateWorkshops.getUrl()}
            size="sm"
          >
            Lernreisen verwalten
          </DropdownLink>
          <DropdownLink
            close={close}
            linkHost={linkHost}
            to={ROUTES.allComments.getUrl()}
            size="sm"
          >
            Moderate
          </DropdownLink>
          <DropdownLink
            close={close}
            linkHost={linkHost}
            to={ROUTES.managePublicShowrooms.getUrl()}
            size="sm"
          >
            Public Showrooms
          </DropdownLink>
        </>
      )}
    </div>
  );
}
